import { Component } from '@angular/core';
import { PageService, SortService, FilterService, ResizeService, FreezeService } from '@syncfusion/ej2-angular-grids';
import { TransferFundResponseDto } from '../../shared/models/transferFundResponseDto';
import { ViewUserTransferComponent } from '../../view-user-transfer/view-user-transfer.component';
import { RequestType } from '../../enums/request-type.enum';
import { ServerPagedHistoryGrid } from '../../shared/grid/server-paged-history-grid';
import type { GridFields } from '../../shared/utils/grid-request';

@Component({
    selector: 'xp-user-transfer-history',
    templateUrl: './user-transfer-history.component.html',
    styleUrl: './user-transfer-history.component.scss',
    providers: [PageService, SortService, FilterService, ResizeService, FreezeService]
})
export class UserTransferHistoryComponent extends ServerPagedHistoryGrid<TransferFundResponseDto> {
    protected readonly requestType = RequestType.TransferFund;
    protected readonly path = 'transfer-fund';
    protected readonly completedRoute = 'transfer-completed-requests';
    protected readonly filterKey = 'transfer';
    protected readonly sheetName = 'Transfer Requests';
    protected readonly exportFileName = 'User Transfer Requests';
    protected readonly fields: GridFields = {
        id: 'number',
        dateRequested: 'date',
        matterNo: 'number',
        matter: 'text',
        type: 'text',
        client: 'text',
        currencyCode: 'text',
        amount: 'number',
        clientBankAccountName: 'text',
        reason: 'text',
        partnerAuthorisingName: 'text',
        dateAuthorised: 'date',
        dateTransaction: 'date',
        recentStatus: 'text',
        returnReason: 'text'
    };

    onViewTransfer(request: TransferFundResponseDto): void {
        this.openDetails(ViewUserTransferComponent, request);
    }

    protected exportRow(item: TransferFundResponseDto): Record<string, unknown> {
        const row: Record<string, unknown> = {
            'Request Id': item.id || '',
            'Requested Date': this.exportDate(item.dateRequested),
            'Matter No': item.matterNo || '',
            'Matter': item.matter || '',
            'Type': item.type || '',
            'Client': item.client || '',
            'Currency': item.currencyId ?? '',
            'Transfer Amount': item.amount ?? '',
            'Partner': item.partnerAuthorisingName || '',
            'Date Authorised': this.exportDate(item.dateAuthorised),
            'Transaction Date': this.exportDate(item.dateTransaction),
            'Status': item.recentStatus || ''
        };
        if (this.isCompletedTab) {
            row['Reason for Transfer'] = item.reason || '';
            row['Client Bank Account Name'] = item.clientBankAccountName || '';
            row['Rejected Reason'] = item.returnReason || '';
        }
        return row;
    }
}
